
import React, { useContext, useState, Fragment, useRef } from 'react'

import useLog from '../../hooks/useLog.js'
import useTxSender from '../../hooks/useTxSender.js'

import { forceInt } from "../../helpers/helpers.js"
import { FormattedNumber } from "../../components/FormattedNumber"
import { Row } from "../../components/Row"
import { Spaces } from "../../components/Spaces"
import { TextDisplay } from "../../components/TextDisplay/TextDisplay"
import { satoshis_to_eur } from '../../helpers/convert_bsv_tokens.js'
import SoldeBSV from '../../components/SoldeBSV.js'
import InputAmountBSV from '../../components/InputAmountBSV.js'
import SuccessTxSender from '../../components/SuccessTxSender.js'
import { default_func_jsx_fail } from '../../helpers/helpers.js'
import InputTokenAddress from '../../components/InputTokenAddress.js'
import { UserContext } from '../../Contexts/UserContext/UserContext.js'
import { ButtonPrimary } from '../../components/Buttons.js'



// tests for debugging the management of errors
const test_txfailtoload = false
const test_broadcastfails = false


export default function Slide_Send_BSV(props) {
	const function_id = "Slide_Send_BSV: "
	const log = useLog(function_id)
	const userContext = useContext(UserContext)

	// --- VARS ---

	const tokenID = "bsv"
	const tokenName = "BSV"
	const tokenActionID = tokenID + "_send" // or send_bsv ?

	const tokenName_plural = tokenName
	const mess_default = "" //"Un récapitulatif des "+tokenName_plural+" à envoyer va s'afficher ici"

	// state & refs
	const [bsv_address, set_bsv_address] = useState("")
	const [bsv_nbsatoshis, set_bsv_nbsatoshis] = useState("")
	const [bsv_inputType, set_bsv_inputType] = useState(null)
	const [send_all, set_send_all] = useState(false)

	const ref_messageEndRef = useRef(null) // for autoscroll

	const array_bool_user_inputs = [
		Boolean(send_all || (bsv_nbsatoshis && bsv_nbsatoshis > 0)),
		Boolean(bsv_address && bsv_address.length > 0),
	]

	const bsv_balance = userContext.balance_bsv //context.tokens_balance[tokenID]
	const bool_context_has_loaded = (bsv_balance != null) && (userContext.bsvprice != null)
	const eur_val = satoshis_to_eur(bsv_nbsatoshis, userContext.bsvprice)

	// --- FUNCTIONS ---


	async function func_empty_fields() {
		set_bsv_address("")
		set_bsv_nbsatoshis("")
		set_send_all(false)
	}

	// useTxSender will send userContext to this func as arg
	const func_onSuccess_once = async (userContext) => {
		// refresh BSV balance + fetch new txs (reuses cached tx details, only
		// enriches new ones). Fire-and-forget so the success UI shows instantly.
		userContext.reload_bsv()
	}

	var jsx_loading = null //<LoaderWithMess mess={mess_default} />
	var jsx_recap = null // add each field one by one

	const jsx_sending = <Fragment>
		Sending &nbsp;
		{send_all
			? "ALL"
			: <Fragment><FormattedNumber value={eur_val} decimals="2" separator=" " /> € of BSV</Fragment>}
		&nbsp;to address {bsv_address}<br /><br />

		Please wait... <i className="reloadIcon fas fa-sync fa-spin" />
	</Fragment>


	const func_jsx_success = (txstate) => {
		// read the amount from txstate (persisted) rather than from local
		// input state, because func_empty_fields() resets bsv_nbsatoshis to ""
		// on success and would otherwise show "0.00 €" here.
		const eur_val_success = satoshis_to_eur(txstate.nbsatoshis, userContext.bsvprice)
		const amount_label = txstate.send_all
			? "ALL"
			: <Fragment><FormattedNumber value={eur_val_success} decimals="2" separator=" " /> € of BSV</Fragment>
		return (
			<SuccessTxSender txstate={txstate}>
				{amount_label} successfully sent to {txstate.sendto_address}
			</SuccessTxSender>
		)
	}

	// --- HOOK useTxSender ---

	const [
		bool_broadcast_lock,
		func_resetMess,
		dict_sendbutton_style,
		jsx_mess,
	]
		= useTxSender(
			tokenActionID,
			array_bool_user_inputs,
			bool_context_has_loaded,
			ref_messageEndRef,
			mess_default,
			jsx_loading,
			jsx_recap,
			jsx_sending,
			func_jsx_success,
			default_func_jsx_fail,
			func_empty_fields,
			func_onSuccess_once,
		)

	// --- FUNCTIONS ---

	function handleChange_validAddress(new_bsv_address) {
		const function_id_2 = function_id + "handleChange_address(): "
		const log = (...args) => { console.log(function_id_2, ...args) }

		if (bool_broadcast_lock) return // don't allow edit during sending
		func_resetMess()

		log("new address to send to:", new_bsv_address)
		set_bsv_address(new_bsv_address)
	}

	function handleChange_nbsatoshis(nbsatoshis, inputType = null) {
		const function_id_2 = function_id + "handleChange_nbsatoshis(): "
		const log = (...args) => { console.log(function_id_2, ...args) }

		if (bool_broadcast_lock) return // don't allow edit during sending
		func_resetMess()

		var val = forceInt(nbsatoshis)
		if (Number.isNaN(val)) val = ""
		if (val < 0) val = -1 * val
		log("new bsv_nbsatoshis = ", val)

		set_bsv_nbsatoshis(val)
		set_bsv_inputType(inputType)
	}

	function handleClick(event) {
		event.preventDefault() // prevent redirection
		if (!bool_broadcast_lock) {
			// async but we don't want to await here !
			userContext.sendtx_BSV(bsv_address, bsv_nbsatoshis,
				test_txfailtoload, test_broadcastfails, send_all
			)
		}
	}

	function handleChange_sendAll(checked) {
		if (bool_broadcast_lock) return
		func_resetMess()
		set_send_all(checked)
	}

	log("\n bsv_address =", bsv_address,
		"\n bsv_nbsatoshis =", bsv_nbsatoshis,
		"\n bsv_inputType=", bsv_inputType,
		"\n bool_broadcast_lock=", bool_broadcast_lock,
		"\n array_bool_user_inputs=", array_bool_user_inputs)

	var button_text = "Send"
	if (send_all) {
		button_text = "Send ALL"
	} else if (eur_val && eur_val > 0) {
		button_text = "Send " + eur_val + "€ of BSV"
	}

	return (
		<div>
			<h1><i className="fas fa-paper-plane" /><Spaces count="3" />
				Send BSV
			</h1>
			<br />

			<center><SoldeBSV /></center>
			<br />
			<br />

			<InputTokenAddress
				tokenName={tokenName}
				tokenID={tokenID}
				variant="bsv"
				value={bsv_address}
				onValidChange={handleChange_validAddress}
				title={"Send to " + tokenName + " address"}
			/>

			<Row>
				<label style={{ cursor: "pointer", userSelect: "none", fontSize: "0.95em" }}>
					<input
						type="checkbox"
						checked={send_all}
						onChange={(e) => handleChange_sendAll(e.target.checked)}
						style={{ marginRight: "8px" }}
					/>
					Send ALL ({bsv_balance != null ? <FormattedNumber value={bsv_balance*1e-8} decimals="8" separator=" " /> : "…"} BSV)
				</label>
			</Row>

			<div style={{ opacity: send_all ? 0.4 : 1, pointerEvents: send_all ? "none" : "auto" }}>
				<InputAmountBSV context={userContext} onChange={handleChange_nbsatoshis} />
			</div>
			<br />

			<center>
				<div ref={ref_messageEndRef}>
					{jsx_mess ?
						<Row>
							<TextDisplay>
								{jsx_mess}
							</TextDisplay>
						</Row>
						: null}
				</div>
			</center>

			{/* <Row>
				<button onClick={handleClick} id='bsv_send' className="submitbutton"
					style={{ borderRadius: "100px", padding: "10px 20px", ...dict_sendbutton_style }} >
					{button_text} &nbsp; <i className="fas fa-paper-plane" />
				</button>
			</Row> */}

			<ButtonPrimary onClick={handleClick}
				style={{
					borderRadius: "100px", padding: "10px 20px", width: "100%",
					fontSize: "1.2em", ...dict_sendbutton_style
				}}>
				{button_text} &nbsp; <i className="fas fa-paper-plane" />
			</ButtonPrimary>

		</div>
	)
}
